var _defs, _circle, _path, _path2, _path3, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherReceivableEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 12.427,
    cy: 25.024,
    r: 3.884
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.437 34.239v-.698a3.69 3.69 0 00-3.69-3.69h-6.64a3.69 3.69 0 00-3.69 3.69v.698"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.076 9.396l2.61-1.07-.1 5.9c1.27 1.9 1.3 4.15 1.3 4.15l3.52 1.23v5.56l-3.72 1.36s-.59 1.65-1.72 2.65c-1.16 1.03-2.45 1.59-2.45 1.59l-.79 3.5h-3.49l-.66-3.11h-1.83M25.989 15.205h-7.835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.081 10.288a4.582 4.582 0 118.441-2.566 4.56 4.56 0 01-.76 2.624"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.667,
    cy: 18.655,
    r: 1.501
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.165 18.656c.01-.05.02-.1.03-.14.22-.82-.12-1.7-.78-2.24l-2.3-1.9.8-1.61 3.8 1.28c.84.26 1.78.02 2.37-.65 0 0 2-1.47 2.8-1.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherReceivableEmployee);
export default __webpack_public_path__ + "static/media/otherReceivableEmployee.4fddc0edcc9009cdfb3b8f45b8d10c86.svg";
export { ForwardRef as ReactComponent };